function ReportScheduleCardView(aReportSchedule, aReportName) {
    "use strict";
    this.Id = aReportSchedule.Id;
    this.ScheduleName = aReportSchedule.ReportScheduleName;
    this.EmailFormat = reportEmailFormatFormatter(aReportSchedule.EmailFormatId);
    this.ReportName = aReportName;
    this.ReportScheduleTime = reportScheduleTimeFormatter(aReportSchedule.ReportScheduleTimeId);
    this.ReportScheduleTimeSpan = reportScheduleTimeSpanFormatter(aReportSchedule.ReportScheduleTimeSpanId);
    this.ReportScheduleDate = reportScheduleDateFormatter(aReportSchedule.ReportScheduleDateId);
    this.TypeCSVFlag = aReportSchedule.TypeCSVFlag;
    this.TypeDOCFlag = aReportSchedule.TypeDOCFlag;
    this.TypePDFFlag = aReportSchedule.TypePDFFlag;
    this.TypeRTFFlag = aReportSchedule.TypeRTFFlag;
    this.TypeTXTFlag = aReportSchedule.TypeTXTFlag;
    this.TypeXLSFlag = aReportSchedule.TypeXLSFlag;
    this.AgentId = aReportSchedule.AgentId;
    this.OrganizationName = OrganizationNameFormatter(aReportSchedule.OrganizationId);
    this.OrganizationId = aReportSchedule.OrganizationId;
    this.ReportId = aReportSchedule.ReportId;
}
if (typeof exports !== 'undefined') {
    module.exports = ReportScheduleCardView;
}